// extracted by mini-css-extract-plugin
export default {"cardsContainer":"StoriesPage_cardsContainer__AE+zf","card":"StoriesPage_card__w12Oe","storyImage":"StoriesPage_storyImage__mqfe-","cardContent":"StoriesPage_cardContent__uCmLz"};